import { isString } from 'util';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const replaceHexToString = text => {
  if (!isString(text)) {
    return text;
  }
  return text.split('\n').map(line => line.replace(/<U\+([0-9a-fA-F]+)>+/g, (match, hex) => {
    const decimal = parseInt(hex, 16);
    const char = String.fromCodePoint(decimal);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(decimal) || char === '\u0000') {
      return match;
    }
    return char;
  })).join('\n');
};